<template>
  <div class="personal-detail">
    <div class="personal-detail-box">
      <div class="personal-system-header">
        <div class="personal-system-left">{{`${orgName}—${projectName}`}}</div>
        <div class="personal-system-right">
          <p class="time-count">
            <span class="time-count-title">登录倒计时：</span>
            <span class="time-count-number">{{minutes > 9 ? minutes : '0' + minutes}}</span>分
            <span class="time-count-number">{{seconds > 9 ? seconds : '0' + seconds}}</span>秒
          </p>
          <!-- <div class="system-left">{{projectName}}</div> -->
          <div class="system-right" @click="goBack">退出个人查询</div>
        </div>
      </div>
      <div class="personal-box-detail">
        <div class="personal-detail-top">
          <el-row>
            <el-col :span="12">
              <div class="grid-content text-over" style="margin-top:10px">
                <span>被征收人：</span>
                <span>{{userInfo.propertyOwner}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="margin-top:10px" class="text-over">
                <span>证件号码：</span>
                <span v-if="hasBtn" style="color:red">{{userInfo.certificateNumber}}</span>
                <span v-else>{{userInfo.certificateNumber}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="grid-content text-over" style="margin-top:10px">
                <span>档案号：</span>
                <span>{{userInfo.householdCode}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="margin-top:10px" class="text-over">
                <span>房屋产权地址：</span>
                <span>{{userInfo.address}}</span>
              </div>
            </el-col>
          </el-row>
          <div class="personal-box-btn" v-if="hasBtn">
            <el-dropdown trigger="click">
              <el-button type="primary" size="mini">
                更多产权信息
              </el-button>
              <el-dropdown-menu slot="dropdown" style="max-height: 400px;overflow: auto;">
                <el-dropdown-item v-for="(item,index) in fileInformationList" :key="index">
                  <div @click="selectFileNumber(item)">
                    <span>档案号：</span>
                    <span>{{item.householdCode}}</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="personal-attachment-box">
          <div class="personal-information-left">
            <div class="personal-information-title">信息公示</div>
            <div v-if="hasAttachmentList" class="personal-box-attachment">
              <div v-for="(item, index) in attachmentList" :key="index">
                <div class="personal-information-one" :class="index == active ? 'active':''" @click="searchAttachment(index,item)">{{item.publicityName}}</div>
              </div>
            </div>
            <div v-else class="personal-picture">
              <div style="color:#999999;font-size: 13px;">暂无公示信息</div>
            </div>
          </div>
          <div class="attachment-information-right">
            <div class="attachment-information-two" v-if="hasattachmentNewList">
              <div style="box-sizing: border-box;padding:10px 13px;" v-for="(item, index) in attachmentNewList" :key="index">
                <div class="attachment-information-test">
                  <div class="attachment-information-name">{{item.suffix}}</div>
                  <div class="attachment-information-fileName">{{item.fileName}}</div>
                  <div class="table-wrap-img" :class="getImgSrc(item.fileName, item.suffix)" style="background-size: 100% 100%;">
                    <div class="photo-content" v-show="reg4.test('.' + item.suffix)" @click="getPhotoAlbums(item.id)">
                      <span class="el-upload-list__item-actions">
                        <span class="photo-large-preview-icon">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                      <img alt :src="item.previewURL" style="width: 120px" />
                    </div>
                    <div class="photo-content" v-show="!reg4.test('.' + item.suffix) && !reg3.test('.' + item.suffix)" @click="handlePreview(item.id)">
                      <span class="el-upload-list__item-actions">
                        <span class="photo-large-preview-icon">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                    </div>
                    <div class="photo-content" v-show="reg3.test('.' + item.suffix)" @click="previewPdf(item.id,item.householdId)">
                      <span class="el-upload-list__item-actions">
                        <span class="photo-large-preview-icon">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page-box">
                <el-pagination background @current-change="handleSizeChange" :current-page.sync="pageNo" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total"></el-pagination>
              </div>
            </div>
            <div class="public-information" v-else>
              <div style="text-align: center;">
                <img src="../../../assets/img/company.png" />
                <div style="color:#999999;font-size: 13px;">暂无公示信息</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gov-pdf-preview :visible="pdfVisible" :pdf-url="pdfSrc" @close="pdfVisible = false" :loading="pdfLoading"></gov-pdf-preview>
    <viewer :images="images" :options="viewOptions" :fulled="true" @inited="inited" style="display: none;" class="viewer" ref="viewer">
      <template slot-scope="scope">
        <img v-for="src in scope.images" :src="src" :key="src" />
        {{scope.options}}
      </template>
    </viewer>
  </div>
</template>
<script>
import { setSession, getSession, removeSession } from '@/untils';
import {
  getImgSrcType,
  getImageIndex,
  decodeURI,
  previewPageOffice,
  getBlob
} from '@/untils';
import {
  getFileInformationList,
  getHouseholdAttachmentList,
  getPublicityProject,
  getPublicityCatalogList,
  queryHouseholdIndex,
  logoutHouseholdIndex
} from '@/api/publicinquiry.api.js';
import GovPdfPreview from '@/components/common/gov-pdf-preview';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer/src/component.vue';
import { removeToken } from '@/untils/auth.js';
import Cookies from 'js-cookie';
export default {
  components: {
    Viewer,
    GovPdfPreview
  },
  data() {
    return {
      images: [],
      pdfLoading: false,
      pdfVisible: false,
      pdfSrc: '',
      attachmentList: [],
      active: '0',
      pictLoading: false,
      attachmentNewList: [],
      reg1: /\.(xlsx|xls)$/,
      reg2: /\.(docx|doc)$/,
      reg3: /\.(pdf)$/,
      reg4: /\.(gif|jpg|pic|png|dwg|dws|dwt|dxf|jpeg|bmp|tiff)$/,
      reg5: /\.(mp4|rmvb|flv|mpeg|avi)$/,
      userInfo: {},
      fileInformationList: [],
      attachmentTypeId: '', //默认查询第一条数据
      contentType: '',
      householdId: '',
      total: 0,
      pageNo: 1,
      pageSize: 10,
      certificateNumber: '',
      householdCode: '',
      viewOptions: {
        // inline: true,
        container: 'body',
        backdrop: true,
        button: true
      },
      imgPreviewURL: '',
      viewer: null, // 预览插件
      projectId: '',
      orgName: '',
      projectName: '',
      time: null, // 定时器
      minutes: 10, // 分
      seconds: 0, // 秒
    };
  },
  computed: {
    hasBtn() {
      return this.fileInformationList.length > 1;
    },
    hasAttachmentList() {
      return this.attachmentList.length > 0;
    },
    hasattachmentNewList() {
      return this.attachmentNewList.length > 0;
    }
  },
  methods: {
    // 倒计时
    timeNum(n) {
      return n < 10 ? '0' + n : '' + n
    },
    countTime() {
      var _this = this
      this.time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0
          window.clearInterval(this.time)
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },
    goBack() {
      this.$confirm('确定要退出个人查询么?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logoutHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              removeSession('token');
              removeSession('session');
              removeSession('selectFlag');
              removeSession('tierBuildingHouseIds');
              removeSession('highBuildingHouseIds');
              removeSession('userInfo');
              Cookies.remove('token');
              Cookies.remove('yz_session_id');
              this.$router.push({ path: '/personal' });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    handleSizeChange(page) {
      this.pageNo = page;
      this.getHouseholdAttachmentList(
        this.householdId,
        this.attachmentTypeId,
        this.contentType
      );
    },
    searchAttachment(index, item) {
      this.pageNo = 1;
      this.active = index;
      this.contentType = item.contentType;
      this.attachmentTypeId = item.attachmentTypeId;
      this.getHouseholdAttachmentList(
        this.householdId,
        item.attachmentTypeId,
        item.contentType
      );
    },
    // 获取公示目录
    getPublicityCatalogList() {
      getPublicityCatalogList(this.projectId).then(res => {
        this.attachmentList = res.body;
        this.householdId = getSession('userInfo') ? getSession('userInfo').householdId : '';
        let params = {
          householdId: this.householdId
        };
        queryHouseholdIndex(this.projectId, params).then(res => {
          this.userInfo = res.body;
          setSession('userInfo', this.userInfo);
          this.householdId = this.userInfo.householdId;
        });
        if (this.attachmentList.length > 0) {
          this.attachmentTypeId = this.attachmentList[0].attachmentTypeId;
          this.contentType = this.attachmentList[0].contentType;
          let params = {
            householdId: this.householdId
          };
          queryHouseholdIndex(this.projectId, params).then(res => {
            this.userInfo = res.body;
            setSession('userInfo', this.userInfo);
            this.householdId = this.userInfo.householdId;
            this.getHouseholdAttachmentList(
              this.householdId,
              this.attachmentTypeId,
              this.contentType
            );
          });
        }
      });
    },
    // 下拉选择档案号查询
    selectFileNumber(item) {
      // this.active = '0';
      this.pageNo = 1;
      this.householdId = item.householdId;
      this.householdCode = item.householdCode;
      this.certificateNumber = item.certificateNumber;
      this.getHouseholdAttachmentList(
        this.householdId,
        this.attachmentTypeId,
        this.contentType
      );
      this.queryHouseholdIndex();
    },
    // 查询公示项目分户档案信息
    queryHouseholdIndex() {
      let params = {
        householdId: this.householdId
      };
      queryHouseholdIndex(this.projectId, params).then(res => {
        this.userInfo = res.body;
        setSession('userInfo', this.userInfo);
        this.householdId = this.userInfo.householdId;
      });
    },
    // 查询目录下的分户附件
    getHouseholdAttachmentList(householdId, attachmentTypeId, contentType) {
      // let loadingInstance = Loading.service({
      //   text: '加载中',
      //   target: document.querySelector('.loadingtext'),
      //   spinner: 'el-icon-loading'
      // });
      let params = {
        householdId,
        attachmentTypeId,
        contentType,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      getHouseholdAttachmentList(this.projectId, params).then(res => {
        if (res.code === 0) {
          if (res.body.records) {
            res.body.records.forEach(item => {
              if (this.reg4.test('.' + item.suffix)) {
                const url = decodeURI(
                  `/project/householdAttachment/${this.projectId}/showHouseholdLittleImg/${item.id}?path=${item.littleImg}`
                );
                item.previewURL = url;
              }
            });
            this.attachmentNewList = res.body.records;
            this.total = res.body.total;
          }
        }
      });
    },
    // 查询项目所有档案信息
    getFileInformationList() {
      getFileInformationList(this.projectId).then(res => {
        this.fileInformationList = res.body;
      });
    },
    getImgSrc(fileName, suffix) {
      return getImgSrcType(fileName, suffix);
    },
    // 初始化完一个预览组件
    inited(viewer) {
      this.viewer = viewer;
      this.$nextTick(() => {
        if (this.images && this.images.length > 0) {
          let index = getImageIndex(this.images, this.imgPreviewURL);
          this.showImg(index);
        }
      });
    },
    // 打开预览组件
    showImg(index) {
      this.viewer.view(index);
    },
    previewPdf(id, householdId) {
      const url = decodeURI(
        `/project/householdAttachment/${this.projectId}/downloadHouseholdAttachmentById/${id}`
      );
      // let params = {
      //   id: id
      // };
      this.pdfSrc = decodeURI(
        `/project/householdAttachment/${this.projectId}/downloadHouseholdAttachmentById/${id}`
      );
      this.pdfVisible = true;
      this.pdfLoading = true;
      getBlob(url).then(res => {
        this.pdfLoading = false;
      });
    },
    handlePreview(id) {
      const url = `/report/pageoffice/summary/previewHouseholdAttachment/${this.projectId}/${id}`;
      previewPageOffice(url);
    },
    getPhotoAlbums(id) {
      this.images = [];
      this.imgPreviewURL = decodeURI(
        `/project/householdAttachment/${this.projectId}/showHouseholdImage/${id}`
      );
      this.attachmentNewList.forEach(item => {
        if (this.reg4.test('.' + item.suffix)) {
          const url = decodeURI(
            `/project/householdAttachment/${this.projectId}/showHouseholdImage/${item.id}`
          );
          this.images.push(url);
        }
      });
    }
  },
  created() {
    // this.userInfo = getSession('userInfo');
    this.projectId = getSession('projectId');
    // this.householdId = this.userInfo.householdId;
    // this.queryHouseholdIndex();
    this.getPublicityCatalogList();
    this.getFileInformationList();
    this.orgName = getSession('newOrgName');
    this.projectName = getSession('projectName');
    // this.queryPublicityItemPage();
  },
  mounted() {
    this.countTime()
  },
  beforeDestroy() {
    // 销毁定时器
    window.clearInterval(this.time)
  },
};
</script>
<style>
.personal-detail {
  height: 100%;
}
.personal-detail-box {
  height: 100%;
  background: #ffffff;
}
.personal-box-detail {
  padding: 10px;
  overflow: auto;
  height: calc(100% - 70px);
}
.personal-detail-top {
  position: relative;
  height: 70px;
  background: rgb(242, 242, 242);
}
.personal-system-header {
  height: 40px;
  border-bottom: 1px solid rgb(2, 91, 145);
}
.personal-system-left {
  float: left;
  padding: 5px 0;
  text-indent: 15px;
  color: #025b91;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
}
.personal-system-right {
  float: right;
  display: flex;
}
.time-count{
  padding: 5px 25px;
}
.time-count-title{
  color: #025b91;
  font-weight: 700;
  font-size: 18px;
}
.time-count-number{
  padding: 5px;
  background-color: #ff9900;
  color: #fff;
  font-weight: bold;
  margin-right: 5px;
}
.system-left {
  padding: 5px 150px;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #1e1e1e;
}
.system-right {
  line-height: 30px;
  text-align: center;
  width: 100px;
  height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.grid-content {
  margin-left: 50px;
}
.personal-box-btn {
  position: absolute;
  right: 0;
  top: 0;
}
.el-button--primary {
  background: #ffffff;
  color: #025b91;
  background-color: #025b91;
  border-color: #025b91;
}
.el-button--primary:hover {
  background-color: #025b91;
  border-color: #025b91;
}
.el-button--primary:focus {
  background-color: #025b91;
  border-color: #025b91;
}
.el-button.is-disabled {
  color: #c0c4cc !important;
}
.personal-attachment-box {
  font-size: 14px;
  height: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}
.personal-information-left {
  width: 16%;
  height: 100%;
  background: rgb(242, 242, 242);
}
.attachment-information-right {
  width: 100%;
  background: rgb(242, 242, 242);
  margin-left: 10px;
  height: 555px;
}
.personal-information-title {
  color: #333333;
  font-weight: 600;
  padding: 10px;
}
/* .personal-box {
  overflow: auto;
  height: 92%;
} */
.personal-information-one {
  height: 36px;
  line-height: 36px;
  text-indent: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.personal-information-one:hover {
  color: #025b91;
}
.personal-picture {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70%;
}
.active {
  border-left: 2px solid #025b91;
  color: #025b91;
}
.personal-information-right {
  width: 100%;
  background: #ffffff;
  margin-left: 10px;
  height: 100%;
}
.personal-box-attachment {
  overflow: auto;
  height: 515px;
  background: rgb(242, 242, 242);
}
.attachment-information-two {
  width: 96%;
  /* background: red; */
  height: 100%;
  display: flex;
  flex-flow: row wrap;
  margin: auto;
  overflow: auto;
}
.public-information {
  width: 96%;
  /* background: red; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attachment-information-test {
  width: 160px;
  height: 210px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.349019607843137);
  cursor: pointer;
  background: #ffffff;
}
.attachment-information-name {
  width: 50px;
  height: 20px;
  line-height: 20px;
  background-color: #025b91;
  color: #ffffff;
  text-align: center;
}
.attachment-information-img {
  width: 105px;
  height: 120px;
  margin: auto;
  margin-top: 8px;
}
.information-box-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.photo-content {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  height: 100px;
  position: relative;
  width: 120px;
  margin: 0 auto;
}

.photo-content img {
  width: 100%;
  height: 100px;
}
.photo-content:hover .el-upload-list__item-actions {
  opacity: 1;
}
.el-upload-list__item-actions {
  position: absolute;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: pointer;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.photo-large-preview-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.table-wrap-img {
  text-align: center;
  height: 100px;
  margin: 16px;
  width: 120px;
}
.xls {
  background: url(../../../assets/img/excel.png) no-repeat;
}
.doc {
  background: url(../../../assets/img/word.png) no-repeat;
}
.pdf {
  background: url(../../../assets/img/pdf.png) no-repeat;
}
.jpg {
  background: url(../../../assets/img/jpg.png) no-repeat;
}
.video {
  background: url(../../../assets/img/video.png) no-repeat;
}
.page-box {
  text-align: right;
  margin-top: 30px;
  width: 100%;
}
.page-box .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #025b91 !important;
  color: #fff !important;
}
.text-over {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.attachment-information-fileName {
  padding: 5px 10px;
  height: 30px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.viewer-toolbar ul li:nth-child(5) {
  position: fixed;
  top: 45%;
  left: 15%;
}
.viewer-toolbar ul li:nth-child(7) {
  position: fixed;
  top: 45%;
  right: 15%;
}
.viewer-toolbar > ul > li {
  height: 50px !important;
  width: 50px !important;
}
.viewer-toolbar > ul > .viewer-large {
  height: 60px !important;
  width: 60px !important;
}
.viewer-toolbar > ul > li::before {
  margin: 15px !important;
}
.viewer-toolbar > ul > .viewer-large::before {
  margin: 20px !important;
}
</style>
<style media="screen">
/*分辨率高于1440，采用下面的样式*/
@media screen and (min-device-height: 1020px) {
  .personal-box-attachment {
    height: 660px;
  }
  .attachment-information-right {
    height: 700px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/personal/personal-detail.vue